export const selectIntroduction = (state) => state.view_introduction;

export const introductionLoading = (state) => {
  const introduction = selectIntroduction(state);
  return introduction.isLoading;
};
